import { ChatMessage, ChatMessageType } from '../model/types';

export type OrgAiConversationHistoryResponse = {
  body: unknown;
  options: unknown;
  response: unknown;
  data: Array<{
    id: string;
    content: Array<{ text: { value: string } }>;
    createdAt: string;
    role: ChatMessageType;
  }>;
};

export const orgAiConversationHistoryResponseToMessages = (
  response: OrgAiConversationHistoryResponse | undefined,
): Array<ChatMessage> => {
  if (!response || !response.data) {
    return [];
  }

  return response.data
    .map((item) => ({
      id: item.id,
      text: item.content[0].text.value,
      created: {
        at: item.createdAt,
        by: {
          type: item.role,
        },
      },
    }))
    .reverse();
};
